module.exports = __webpack_public_path__ + "static/media/blog4.5de2130f.jpg";